import { Search } from '~/router/routes/car/classifieds/search/components'
import { interopDefault } from '~/router/utils'

export const myClassifiedRoutes = [
  {
    name: '__classifieds_search_my_classifieds',
    path: '/classifieds/my/',
    component: Search,
    meta: { isSearchRoute: true, wideContainer: true }
  },
  {
    name: '__classifieds_search_my_classifieds_drafts',
    path: '/classifieds/my/drafts',
    component: () =>
      interopDefault(
        import(
          '~/pages/car/incomplete-classifieds.vue' /* webpackChunkName: "pages-car-incomplete-classifieds" */
        )
      )
  }
]
